import { getDialogMode, DIALOGMODE } from './ImService'
import { IMEventBus } from 'lib/mp-stjk-im-service'

/**
 * 处理context内部renderInfo相关
 */
const InputType = {
  CHAT_MSG: 0,
  LEAVE_MSG: 1,
};
class ImRenderHandler {
  constructor() {
    this._reloadTimer = null
  }

  /**
   * 处理renderInfo
   * @param param
   * @param doctorId
   */
  handleRenderInfo(
    commonInfo,
    renderInfo,
    imDoctor,
    doctorId,
    groupId,
    needScrollBottom
  ) {
    // // 获取当前对话框所处模式
    const dialogMode = getDialogMode(
      0,
      renderInfo.dialogActive||0,
      imDoctor.entranceDoctor.doctorId||0,
      0
    )

    if (!renderInfo.textIsOpen) {
      // 对话框失效
      if (renderInfo && renderInfo.dialogActive === 0) {
        const extendInfo = JSON.parse(commonInfo.extendInfo || '{}')
        const renewDisplayInfo = JSON.parse(extendInfo.renewDisplayInfo || '{}')
        const { tipText } = renewDisplayInfo || {};
        if (tipText) {
          // 底部按钮续费
          IMEventBus.trigger('OPTION_CONTROL_MSG', 'PRIVATE_DOCTOR_RENEW', { renewDisplayInfo, doctorId, groupId })
          // 续费
          IMEventBus.trigger('INVALID_ACCOUNT_RENEW', commonInfo)
        }
      } else {
        // 医生离线
        if(renderInfo.dialogActive&&commonInfo.extendInfo)
          this.handleDoctorOffline(commonInfo.extendInfo)
      }
    } else {
      // this.handleTextIsOpen(commonInfo, consultantInfo, dialogMode, renderInfo, needScrollBottom)
      this.handleTextIsOpen(dialogMode,needScrollBottom)
    }
  }

  /**
   * 处理输入框是否展示
   * @param textIsOpen
   */
  handleTextIsOpen(dialogMode,needScrollBottom) {
    let inputProps = { inputType: InputType.CHAT_MSG }
    // 留言模式 输入框默认文案需要自定义
    if (dialogMode === DIALOGMODE.LEAVEMSG) {
      inputProps.placeHolder = '输入文字进行留言'
    }

    IMEventBus.trigger('control-emitter', false)
    IMEventBus.trigger('emit_panel_msg', 'input_emitter', true, inputProps)

    if (needScrollBottom) {
      setTimeout(() => { IMEventBus.trigger('REFRESH_SCROLLER') }, 50)
    }
  }

  /**
   * 医生离线
   */
  handleDoctorOffline(extendInfo) {
    IMEventBus.trigger('OPTION_CONTROL_MSG', 'DOCTOR_OFFLINE', JSON.parse(extendInfo))
  }

}
export { ImRenderHandler }
export default new ImRenderHandler()
